import { render, staticRenderFns } from "./RsaConfigurazioneSettingsListPage.vue?vue&type=template&id=f6da8d4c"
import script from "./RsaConfigurazioneSettingsListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSettingsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports